import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';

const FOLDERS_KEY = ['folders'];

export interface Folder {
  id: string;
  name: string;
  parentId: string | null;
  color: string | null;
  position: number;
}

export function useFolders() {
  return useQuery({
    queryKey: FOLDERS_KEY,
    queryFn: async () => {
      const { data } = await api.get<{ data: Folder[] }>('/folders');
      return data.data;
    },
  });
}

export function useCreateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { name: string; parentId?: string | null; color?: string | null }) => {
      const { data } = await api.post<{ data: Folder }>('/folders', payload);
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FOLDERS_KEY });
    },
  });
}

export function useUpdateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: { name?: string; parentId?: string | null; color?: string | null } }) => {
      const { data } = await api.put<{ data: Folder }>(`/folders/${id}`, payload);
      return data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FOLDERS_KEY });
    },
  });
}

export function useDeleteFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      await api.delete(`/folders/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FOLDERS_KEY });
    },
  });
}
